import React from "react";
import { Card, CardTop, CardBody, CardFooter } from "@adeccoux/tag-ds";
import { buildDeviceNames } from "../../util/common";
import { useNavigate } from "react-router";
import DisplayButton from "../../util/displaybutton";
const SessionCompleted = ({
    user,
    testDetails,
    phrases,
    accessibilityStatus,
    grantExtratiming,
    deviceList,
    candidatereportcheck,
    npsSurveyUrl,
    candidateList,
    presentScreen,
    setPresentScreen,
}) => {
    const navigate = useNavigate();
    const thankYouMessage = phrases?.["20022541"]?.split(":");
    const allowNpsSurvey =
        user?.siteConfig?.allowNpsSurvey === "Y" && npsSurveyUrl !== null;
    const brandName = user?.siteConfig?.templatesConfig?.welcomeTemplate
        ?.split("Brand")[1]
        ?.replace("&nbsp;", " ")
        ?.trim();

    const handlePageChange = (screen) => {
        setPresentScreen(screen);
    };

    const openReport = (receivedURL) => {
        let url = receivedURL;
        if (user.siteConfig.langId) {
            url = url + "&language_id=" + user.siteConfig.langId;
        }
        window.open(
            url,
            "",
            "resizable=YES,toolbar=no,top=" +
            200 +
            ",left=" +
            200 +
            ",width=650,height=475,scrollbars=YES"
        );
    };

    const logOut = () => {
        sessionStorage.clear();
        window.location.replace("/loginNew?stc=candidate");
    };

    const backButton = () => {
        window.history.back();
    };

    return (
        <>
            {presentScreen === "session" && (
                <>
                    <div className="flex_col g2 base text-02 xpert-align-self-stretch">
                        <h3 className="text-01">{thankYouMessage?.[0]}</h3>
                        <div className="text-02">
                            {thankYouMessage?.[1]}
                        </div>
                    </div>

                    {allowNpsSurvey && (
                        <div className="flex flex_wrap g4 g2_mobile text_uppercase">
                            {user.inBranch == false &&
                                candidatereportcheck == true && (
                                    <a role="link"
                                        onClick={() =>
                                            handlePageChange("result")
                                        }
                                    >
                                        {phrases?.["10022053"]}
                                        <span className="material-icons right">
                                            bar_chart
                                        </span>
                                    </a>
                                )}
                            <a role="link" onClick={() => handlePageChange("survey")}>
                                {phrases?.["20022542"]}
                                <span className="material-icons-outlined right">
                                    forum
                                </span>
                            </a>
                        </div>
                    )}
                    <div className="flex_col g2 xpert-align-self-stretch align-items_start g-container_12 welcome_instruments">
                        <div className="flex flex_wrap g2 xpert-align-self-stretch align-items_start">
                            {testDetails.length > 0 &&
                                testDetails.map((val, ind) => (
                                    <div className="flex g2 xpert-align-self-stretch align-items_start g-item_4 g-item_tablet_3 g-item_mobile_3">
                                        <Card key={ind}>
                                            <CardTop id="card top">
                                                <div className="status-tag_success text_uppercase">
                                                    {val.status.tag}
                                                </div>
                                            </CardTop>
                                            <CardBody id="card body">
                                                <ul className="list-icon_small p0 m0_mobile">
                                                    <li className="flex justify-content_between g2 font-16">
                                                        <span>
                                                            {phrases?.["14522"]}
                                                        </span>
                                                        <span
                                                            style={{
                                                                wordBreak:
                                                                    "break-all",
                                                            }}
                                                        >
                                                            {val.name}
                                                        </span>
                                                    </li>
                                                    <li className="item-double font-16">
                                                        {phrases?.["14523"]}{" "}
                                                        <span>
                                                            {val.instrumentTypeName}
                                                        </span>
                                                    </li>
                                                    <li className="item-double font-16">
                                                        {phrases?.["20023506"]}
                                                        <span>
                                                            {val.timeLimit == 0 &&
                                                                val.timedByTopic ==
                                                                false &&
                                                                val.timeByQuestion ==
                                                                false &&
                                                                "N/A"}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                accessibilityStatus !=
                                                                2 &&
                                                                phrases?.[
                                                                "20023537"
                                                                ]}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                accessibilityStatus ==
                                                                2 &&
                                                                grantExtratiming ==
                                                                0 &&
                                                                phrases?.[
                                                                "20023537"
                                                                ]}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                grantExtratiming !=
                                                                0 &&
                                                                accessibilityStatus ==
                                                                2 &&
                                                                phrases?.[
                                                                "20023513"
                                                                ]}
                                                        </span>
                                                    </li>
                                                    <li className="flex justify-content_between g2 font-16">
                                                        <span>
                                                            {phrases?.["20022535"]}
                                                        </span>
                                                        <span
                                                            style={{
                                                                wordBreak:
                                                                    "break-all",
                                                            }}
                                                        >
                                                            {buildDeviceNames(
                                                                val.deviceType,
                                                                deviceList
                                                            )}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </CardBody>
                                        </Card>
                                    </div>
                                ))}
                        </div>
                    </div>

                    <DisplayButton
                        buttons={[
                            !user.fromCsso && !user.inBranch && (
                                <button
                                    className="button-secondary text_uppercase mt2 full-width_mobile"
                                    onClick={logOut}
                                >
                                    {phrases?.["14870"]}
                                </button>
                            ),
                            user.fromCsso && (
                                <button
                                    className="button-secondary text_uppercase mt2 full-width_mobile"
                                    onClick={backButton}
                                >
                                    {phrases?.["15073"]}
                                </button>
                            )
                        ]} />
                </>
            )}
            {presentScreen === "survey" && (
                <>
                    <div className="flex_col g2 base text-02 xpert-align-self-stretch">
                        <h3 className="text-01">{phrases?.["20022543"]}</h3>
                    </div>
                    <iframe
                        src={npsSurveyUrl}
                        cp-resizable
                        frameborder="0"
                        style={{ height: "100vh", width: "100%" }}
                        id="msFrameId"
                        name="msFrameName"
                    />
                    <div>{brandName ? `Brand${brandName}` : ""}</div>
                    <DisplayButton buttons={[<button className="button-secondary text_uppercase full-width_mobile" onClick={() => handlePageChange("session")}>{phrases?.["15073"]}</button>]} />
                </>
            )}
            {presentScreen === "result" && (
                <>
                    <div className="flex_col g2 base text-02 xpert-align-self-stretch">
                        <h3 className="text-01">
                            {
                                user.siteConfig.templatesConfig[
                                "yourResultsTemplateSub"
                                ]
                            }
                        </h3>
                        <div
                            className="base text-02"
                            dangerouslySetInnerHTML={{
                                __html: user.siteConfig.templatesConfig[
                                    "yourResultsTemplate"
                                ],
                            }}
                        ></div>
                    </div>

                    <div className="flex_col g2 xpert-align-self-stretch align-items_start g-container_12 welcome_instruments">
                        <div className="flex flex_wrap g2 xpert-align-self-stretch align-items_start">
                            {candidateList.length > 0 &&
                                candidateList.map((val, ind) => (
                                    <div className="flex g2 xpert-align-self-stretch align-items_start g-item_4 g-item_tablet_3 g-item_mobile_3">
                                        <Card key={ind}>
                                            <CardTop id="card top">
                                                <div className="status-tag_success text_uppercase">
                                                    {val.status.tag}
                                                </div>
                                            </CardTop>
                                            <CardBody id="card body">
                                                <ul className="list-icon_small p0 m0_mobile">
                                                    <li className="item-double font-16">
                                                        {phrases?.["14523"]}{" "}
                                                        <span>
                                                            {val.instrumentTypeName}
                                                        </span>
                                                    </li>
                                                    <li className="flex justify-content_between g2 font-16">
                                                        <span>
                                                            {phrases?.["14522"]}
                                                        </span>
                                                        <span
                                                            style={{
                                                                wordBreak:
                                                                    "break-all",
                                                            }}
                                                        >
                                                            {val.testName}
                                                        </span>
                                                    </li>
                                                    <li className="item-double font-16">
                                                        {phrases?.["20023506"]}
                                                        <span>
                                                            {val.timeLimit == 0 &&
                                                                val.timedByTopic ==
                                                                false &&
                                                                val.timeByQuestion ==
                                                                false &&
                                                                "N/A"}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                accessibilityStatus !=
                                                                2 &&
                                                                phrases?.[
                                                                "20023537"
                                                                ]}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                accessibilityStatus ==
                                                                2 &&
                                                                grantExtratiming ==
                                                                0 &&
                                                                phrases?.[
                                                                "20023537"
                                                                ]}
                                                            {(val.timeByQuestion ==
                                                                true ||
                                                                val.timedByTopic ==
                                                                true ||
                                                                val.timeLimit !=
                                                                0) &&
                                                                grantExtratiming !=
                                                                0 &&
                                                                accessibilityStatus ==
                                                                2 &&
                                                                phrases?.[
                                                                "20023513"
                                                                ]}
                                                        </span>
                                                    </li>
                                                    <li className="flex justify-content_between g2 font-16">
                                                        <span>
                                                            {phrases?.["20022535"]}
                                                        </span>
                                                        <span
                                                            style={{
                                                                wordBreak:
                                                                    "break-all",
                                                            }}
                                                        >
                                                            {buildDeviceNames(
                                                                val.deviceType,
                                                                deviceList
                                                            )}
                                                        </span>
                                                    </li>
                                                </ul>
                                            </CardBody>
                                            <CardFooter id="card footer">
                                                <a role="link"
                                                    className="text_uppercase"
                                                    onClick={() =>
                                                        openReport(
                                                            val.candidatePdfUrl
                                                        )
                                                    }
                                                >
                                                    {phrases?.["10022054"]}
                                                    <span className="material-icons-outlined right">
                                                        download
                                                    </span>
                                                </a>
                                            </CardFooter>
                                        </Card>
                                    </div>
                                ))}
                        </div>
                    </div>
                    <DisplayButton buttons={[<button className="button-secondary text_uppercase full-width_mobile" onClick={() => handlePageChange("session")}>{phrases?.["15073"]}</button>]} />
                </>
            )}
        </>
    );
};

export default SessionCompleted;
